<a class="dropdown-item" href="#" appStopClick (click)="submit(returnUri, true)"> <i class="fa fa-fw fa-link" aria-hidden="true"></i> {{'linkSso' | i18n}} </a> 